<span class="badge" [ngClass]="current.class">
  {{ current.label }}
</span>
